import { render } from "./PracticeDetails.vue?vue&type=template&id=f1479a20"
import script from "./PracticeDetails.vue?vue&type=script&lang=js"
export * from "./PracticeDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__